<template>
  <section class="Urbanism_and_development_sec">
    <div class="big_container">
      <!-- sec content -->
      <div class="sec_content">
        <div class="sec_content_inner">
          <div class="sec_img">
            <div class="image_grid">
              <img
                v-lazy="shopifyData.SecImg.src"
                :placeholder="shopifyData.SecImg.placeholder"
                :alt="shopifyData.SecImg.alt || 'Urbanism And Development Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Urbanism And Development Image"
                width=""
                height=""
              />
            </div>
          </div>
          <div class="sec_text">
            <h2 class="sec_heading" v-html="sanitizeHtml(shopifyData.secHeading)" />
            <h4
              class="card_heading_b sec_inner_heading"
              v-html="sanitizeHtml(shopifyData.secSubHeading)"
            />
            <p
              v-for="(item, index) in shopifyData.paragraph"
              :key="index"
              class="body_text"
              v-html="sanitizeHtml(item.para)"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sanitizeHtml,
  },
};
</script>

<style scoped>
.Urbanism_and_development_sec {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #e9e7e3 100%);
  padding: 200px 0;
}
.card_heading_b.sec_inner_heading {
  margin: 14px 0;
  text-align: start;
}
.sec_content_inner {
  display: flex;
  align-items: center;
  gap: 107px;
}
.sec_content_inner > div {
  width: 50%;
}
.body_text {
  margin-bottom: 20px;
}
.body_text:last-child {
  margin-bottom: 0;
}
.image_grid img {
  width: 100%;
}
.sec_content {
  padding: 0 50px;
}
/* ===== RESPONSIVE BREAKPOINTS START ===== */
@media screen and (max-width: 1024px) {
  .sec_content_inner {
    gap: 30px;
  }
  .sec_content {
    padding: 0;
  }
}
@media screen and (max-width: 767px) {
  .sec_content_inner {
    flex-direction: column;
  }
  .sec_content_inner > div {
    width: 100%;
  }
  .sec_text {
    padding: 0 20px;
  }
  .Urbanism_and_development_sec {
    padding: 20px 0;
  }
}
</style>
